import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { get } from 'lodash'
import { FormattedMessage } from 'react-intl'
import { compose } from 'recompose'

import { Select, Input, InputDate } from 'components/fields'
import { MaterialModal } from 'components/layout'
import { Title } from 'components/misc'
import { form } from 'helpers/decorators'
import { apiCodeLists, apiConfiguration, apiAssessors, apiDashboard } from 'helpers/decorators/api'
import { initialValuesRP } from 'models/residentialProjects'
import validate from './edit-rp.validation'
import { CONFIGURATION_KEYS } from '../../../../constants/enums'
import { asyncValidate } from '../../../../models/residentialProjects/validateAssessor'
import assessorsDropdownSelector from '../../../../redux/selectors/assessors/assessorsDropdownSelector'
import styles from '../SetupRP/setup-rp.styl'
import { connect } from 'react-redux'
import { isAssessorManagementEnabledForActivity } from '../../../../helpers/assessorHelper'

const enhance = compose(
  apiDashboard.apiResidentialProject({
    loaders: ['edit']
  }),
  apiAssessors(),
  apiConfiguration(),
  connect(({ api }) => ({
    dashboard: api.dashboard,
    assessor: api.assessor
  })),
  apiCodeLists(['titles'], {
    public: true
  }),
  form({
    form: 'editRp',
    disableHook: true,
    validate,
    asyncValidate
  })
)

class EditActivity extends Component {
  static propTypes = {
    onEditRP: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    initialize: PropTypes.func.isRequired,
    reset: PropTypes.func.isRequired,
    residentialProjectId: PropTypes.number,
    editStatus: PropTypes.object,
    codeLists: PropTypes.object,
    residentialProject: PropTypes.object,
    colorClass: PropTypes.string,
    onGetConfigurationValue: PropTypes.func,
    assessor: PropTypes.object
  }

  componentWillMount = async() => {
    this.props.initialize(initialValuesRP(this.props.residentialProject))

    await Promise.all([
      this.props.onGetConfigurationValue(
        CONFIGURATION_KEYS.assessorMandatory.id,
        get(this.props, 'residentialProject.award.organization.id'),
        true
      )])

    this.getAssessorsIfNecessary(this.getSubcategoryValue())
  }

  getAssessorsIfNecessary(subcategoryValue) {
    const orgId = this.getOrgId()

    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(get(this.props, 'residentialProject'))

    if (isAssessorManagementEnabled && subcategoryValue && subcategoryValue !== 'others' && orgId) {
      this.props.onGetAvailableAssessorsForActivityCategory(orgId, subcategoryValue)
    }
  }

  getSubcategoryValue() {
    return get(this.props, 'values.helpers.subcategory')
  }

  getOrgId() {
    return get(this.props, 'dashboard.awards.awards.data.organization.id')
  }

  handleSubmit = fields =>
    this.props.onEditRP(this.props.residentialProjectId, fields, {
      resetForm: this.props.reset,
      residentialProject: this.props.residentialProject
    })

  render() {
    const { codeLists, colorClass, editStatus, handleSubmit, values, assessor,residentialProject } = this.props
    const subcategoryValue = get(values, 'helpers.subcategory')
    const setupAssessorId = get(values, 'setupAssessorId')
    const isAssessorManagementEnabled = isAssessorManagementEnabledForActivity(residentialProject)
    const isOthersSubCategory = subcategoryValue === 'others'
    const isNoneOfTheseAssessor = setupAssessorId === 0
    const needHelpFromAwardLeader = setupAssessorId === -1
    const dropdownAssessors = assessorsDropdownSelector(assessor, false, this.props)

    return (
      <form onSubmit={handleSubmit(this.handleSubmit)}>
        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.residential_project_details"
            defaultMessage="Residential Project Details"
          />
        </Title>

        <Input name="goal" label="Goal" intlKey="label.goal" />

        <InputDate
          name="startDate"
          label="Start Date"
          intlKey="label.start_date"
        />

        <InputDate name="endDate" label="End Date" intlKey="label.end_date" />

        <Title h5 colorClass={colorClass}>
          <FormattedMessage
            id="formTitle.assessor_details"
            defaultMessage="Assessor Details"
          />
        </Title>

        {isAssessorManagementEnabled && <div>
          {!isOthersSubCategory && !needHelpFromAwardLeader && <div className={styles.selectAssessor} ><FormattedMessage
            id="label.select_award_unit_assessor"
            defaultMessage="Select from assessors already approved by your Award Unit or create a new one below."
          /></div>}

          {isOthersSubCategory && <div className={styles.assessorIsDisabled}><FormattedMessage
            id='label.assessor_disabled_for_other_activity'
            defaultMessage='Assessor selection is disabled for other activity.'
          /></div>}
          {!isOthersSubCategory && <div className="row">
            <div className="col-xs-12">
              <Select
                name='setupAssessorId'
                label=""
                intlKey=""
                options={dropdownAssessors}
                disabled={!subcategoryValue || isOthersSubCategory}
              />
            </div>
          </div>}
        </div>}

        {(!isAssessorManagementEnabled || isNoneOfTheseAssessor) && !isOthersSubCategory && <div>
        <div className="row">
          <div className="col-xs-12">
            <Select
              name="assessorTitle"
              label="Title"
              intlKey="label.title"
              options={get(codeLists, 'titles.list')}
            />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input name="assessorName" label="Name" intlKey="label.name" />
          </div>
        </div>

        <div className="row">
          <div className="col-xs-12">
            <Input
              name="assessorEmail"
              label="Email"
              type="email"
              intlKey="label.email"
            />
          </div>
        </div>
          <div className="row">
            <div className="col-xs-12">
              <Input
                name="assessorPhone"
                label="Phone"
                type="phone"
                intlKey="label.phone"
              />
            </div>
          </div>
        </div>}

        <MaterialModal.Footer
          action="Save"
          actionKey="button.save"
          colorClass={colorClass}
          insideContent
          isLoading={get(editStatus, 'loading')}
        />
      </form>
    )
  }
}

export default enhance(EditActivity)
